import { render, staticRenderFns } from "./CanvasChooseASlideType.vue?vue&type=template&id=43311dbf&"
import script from "./CanvasChooseASlideType.vue?vue&type=script&lang=js&"
export * from "./CanvasChooseASlideType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports